import { factoryIntlNumberFormat } from 'src/utils/factoryIntlNumberFormat.ts';

export const getNumberFormat = (currentLocale: string) => {
    if (typeof Intl !== 'undefined') {
        const parts = factoryIntlNumberFormat(currentLocale).formatToParts(Number('1234567.89'));

        const { value: thousandSeparator = ',' } = parts.find((elem) => elem.type === 'group') || {};
        const { value: decimalSeparator = '.' } = parts.find((elem) => elem.type === 'decimal') || {};

        return {
            thousandSeparator,
            decimalSeparator,
        };
    }
    return {
        thousandSeparator: ',',
        decimalSeparator: '.',
    };
};
